import type { Report } from '@k-ucap/shared';
import type { ReportRepository } from './RepositoryInterfaces.js';

const reports: Map<string, Report> = new Map();

export class InMemoryReportRepository implements ReportRepository {
  async findAll(): Promise<Report[]> {
    return Array.from(reports.values()).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }

  async findById(id: string): Promise<Report | undefined> {
    return reports.get(id);
  }

  async findByProjectId(projectId: string): Promise<Report[]> {
    return Array.from(reports.values())
      .filter((r) => r.projectId === projectId)
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }

  async findBySimulationRunId(simulationRunId: string): Promise<Report[]> {
    return Array.from(reports.values())
      .filter((r) => r.simulationRunId === simulationRunId)
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }

  async save(report: Report): Promise<Report> {
    reports.set(report.id, report);
    return report;
  }

  async delete(id: string): Promise<void> {
    reports.delete(id);
  }
}

export const createInMemoryReportRepository = (): InMemoryReportRepository => new InMemoryReportRepository();
